import React from "react";
import { referencesData, ressourcesData } from "./data-indexGraphique";
import "./style.scss";

const IndexGraphique = () => {
  return (
    <div className="index-graphique">
      {/* Colonne Références */}
      <div className="column">
        <h3>RÉFÉRENCES</h3>
        {referencesData.map((category, index) => (
          <div key={index} className="category-block">
            <h4 className="category-title">{category.title}</h4>
            <ul className="category-links">
              {category.links.map((link, i) => (
                <li key={i}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Colonne Ressources */}
      <div className="column">
        <h3>RESSOURCES</h3>
        <ul className="ressources-list">
          {ressourcesData.map((item, i) => (
            <li key={i}>
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default IndexGraphique;